import {call, put} from "redux-saga/effects";
import {setLoading, setImage, setError} from "../../slices/imageUploadSlice";
import {requestRemoveImage, requestUploadImage} from "../requests/imageUploadService";


export function* handleUploadImage(action) {
  const image = action.payload
  try {
    yield put(setLoading())
    const response = yield call(() => requestUploadImage(image))
    yield put(setImage(response.data.image))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

export function* handleRemoveImage(action) {
  const imageUrl = action.payload
  try {
    yield put(setLoading())
    yield call(() => requestRemoveImage(imageUrl))
    yield put(setImage(""))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}